import { render, staticRenderFns } from "./card-company-list.vue?vue&type=template&id=1a365083&"
import script from "./card-company-list.vue?vue&type=script&lang=js&"
export * from "./card-company-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports